export default {
  LOAD_CYCLE_THEORETICAL_PART_FORM_PAGE_START: 'LoadCycleTheoreticalPartFormPageStart',
  LOAD_CYCLE_THEORETICAL_PART_FORM_PAGE_END: 'LoadCycleTheoreticalPartFormPageEnd',
  LOAD_CYCLE_THEORETICAL_PART_TYPES: 'LoadCycleTheoreticalPartTypes',
  LOAD_CYCLE_THEORETICAL_PART_AVAILABLE_THEORETICAL_PARTS_START: 'LoadCycleTheoreticalPartAvailablePartsStart',
  LOAD_CYCLE_THEORETICAL_PART_AVAILABLE_THEORETICAL_PARTS_END: 'LoadCycleTheoreticalPartAvailablePartsEnd',
  LOAD_CYCLE_THEORETICAL_PART_AVAILABLE_TEACHERS_START: 'LoadCycleTheoreticalPartAvailableTeachersStart',
  LOAD_CYCLE_THEORETICAL_PART_AVAILABLE_TEACHERS_END: 'LoadCycleTheoreticalPartAvailableTeachersEnd'
};